import { z } from 'zod';
import type { ValidationResult } from './useWizard';

export function validateWithZod<T extends z.ZodTypeAny>(
  schema: T,
  values: Record<string, unknown>,
): ValidationResult {
  const result = schema.safeParse(values);
  if (result.success) {
    return { isValid: true, errors: {} };
  }
  const errors: Record<string, string> = {};
  for (const issue of result.error.issues) {
    const path = issue.path.join('.');
    if (!errors[path]) {
      errors[path] = issue.message;
    }
  }
  return { isValid: false, errors };
}

export function stepValidator<T extends z.ZodTypeAny>(schema: T) {
  return (values: Record<string, unknown>): ValidationResult => validateWithZod(schema, values);
}
